module.exports = "<ng-template #loadTemplate></ng-template>\r\n"